import { StepComponentType } from '@icc/configurator/shared';
import { ModelComponent } from './model/model.component'
import { LocksComponent } from './locks/locks.component';
import { DimensionsComponent } from '../dimensions/dimensions.component';
import { SystemComponent } from '../system/system.component';
import { LayoutComponent } from '../layout/layout.component';
import { GlazingsComponent } from '../glazings/glazings.component';
import { MuntinsComponent } from '../muntins/muntins.component';
import { FittingComponent } from '../fitting/fitting.component';
import { ConstructionComponent } from '../construction/construction.component';
import { ProductDetailsComponent } from '../product-details/product-details.component';
import { SystemPacketsComponent } from '../system-packets/system-packets.component';
import { ColorsComponent } from '../colors/colors.component';

import { HardwareComponent } from './hardware/hardware.component';
import { SizesComponent } from './sizes/sizes.component';
import { LightsGlazingComponent } from './lights-glazing/lights-glazing.component';
import { WindowAccessoriesComponent } from '../accessories/accessories.component';

export const doorStepsMap: {
    [stepId: string]: StepComponentType;
} = {
    models: ModelComponent,
    dimensions: DimensionsComponent,
    sizes: SizesComponent,
    sashes: LayoutComponent,
    construction: ConstructionComponent,
    system: SystemComponent,
    packets: SystemPacketsComponent,
    color: ColorsComponent,
    fillings: GlazingsComponent,
    lightsglazing: LightsGlazingComponent,
    muntins: MuntinsComponent,
    fitting: FittingComponent,
    hardware: HardwareComponent,
    locks: LocksComponent,
    details: ProductDetailsComponent,
    accessories: WindowAccessoriesComponent,
};
